import React, { useState } from "react";

const FilterDropdown = ({ column, setFilters, filters }: any) => {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(filters[column] || "");

  return (
    <div className="relative inline-block">
      <button
        className="ml-1 text-xs"
        onClick={() => setOpen((o) => !o)}
        title="Filter"
      >
        ⬇
      </button>
      {open && (
        <div className="absolute z-10 bg-white border p-2">
          <input
            className="border px-1"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="Filter..."
          />
          <button
            className="ml-2 text-xs"
            onClick={() => {
              setFilters((f: any) => ({ ...f, [column]: value }));
              setOpen(false);
            }}
          >
            Apply
          </button>
        </div>
      )}
    </div>
  );
};

export default FilterDropdown; 